import { useDeleteGoal, useGetGoalType, useGetGoalStatus } from '_api';
import { useMemo } from 'react';

const useGoals = () => {
  const { data: goalStatus } = useGetGoalStatus();
  const { mutateAsync: deleteGoal } = useDeleteGoal();

  const { data: goalTypeConstants, isLoading: loadingGoalTypes } = useGetGoalType();

  const goalTypeOptions = useMemo(
    () => (goalTypeConstants && !loadingGoalTypes ? goalTypeConstants : []),
    [goalTypeConstants],
  );

  return { deleteGoal, goalStatus, goalTypeOptions };
};

export default useGoals;
